var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMri(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6.6
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#11192A",
    d: "M132 132V17.6c0-4.86-3.94-8.8-8.8-8.8H98.947C78.55-2.934 53.451-2.934 33.053 8.8H8.8C3.94 8.8 0 12.74 0 17.6V132",
    transform: "translate(4.2 4.1)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#11192A",
    d: "M85.741 84.908c-1.285-3.425-4.555-5.697-8.213-5.708H54.495c-3.658.01-6.928 2.283-8.213 5.708L35.2 114.4h61.6L85.741 84.908zM35.2 114.4v8.8c0 4.86 3.94 8.8 8.8 8.8h44c4.86 0 8.8-3.94 8.8-8.8v-8.8",
    transform: "translate(4.2 4.1)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#286DFF",
    d: "M17.6 24.2c1.215 0 2.2.985 2.2 2.2M15.4 26.4c0-1.215.985-2.2 2.2-2.2M17.6 28.6c-1.215 0-2.2-.985-2.2-2.2M19.8 26.4c0 1.215-.985 2.2-2.2 2.2M114.4 24.2c1.215 0 2.2.985 2.2 2.2M112.2 26.4c0-1.215.985-2.2 2.2-2.2M114.4 28.6c-1.215 0-2.2-.985-2.2-2.2M116.6 26.4c0 1.215-.985 2.2-2.2 2.2M39.6 66c0-14.58 11.82-26.4 26.4-26.4 14.58 0 26.4 11.82 26.4 26.4",
    transform: "translate(4.2 4.1)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#11192A",
    d: "M106.333 83.6c8.04-18.44 2.55-39.983-13.333-52.327-15.884-12.344-38.116-12.344-54 0C23.117 43.617 17.627 65.16 25.667 83.6",
    transform: "translate(4.2 4.1)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMri);
export default __webpack_public_path__ + "static/media/mri.d599a1b335492d53ebcf0b716d253ef9.svg";
export { ForwardRef as ReactComponent };